export default __webpack_public_path__ + "static/media/p2.e8306638.png";